import type { SvgIconProps } from '../../types/props.ts'

export const LinkedInIconDark = (props: SvgIconProps) => {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden={true}
      role="img"
      {...props}
    >
      <path
        d="M0 5.99252C0 2.68294 2.92342 0 6.52964 0H41.3544C44.9606 0 47.884 2.68294 47.884 5.99252V42.0075C47.884 45.3171 44.9606 48 41.3544 48H6.52964C2.92342 48 0 45.3171 0 42.0075V5.99252Z"
        fill="black"
        fillOpacity="0.6"
      />
      <path
        d="M6.5293 0.5H41.3545C44.7257 0.500057 47.3836 2.99847 47.3838 5.99219V42.0078C47.3836 45.0015 44.7257 47.4999 41.3545 47.5H6.5293C3.15824 47.4998 0.500199 45.0015 0.5 42.0078V5.99219C0.500198 2.99854 3.15824 0.500169 6.5293 0.5Z"
        stroke="white"
        strokeOpacity="0.1"
      />
      <path
        d="M13.4838 16.3252C15.3901 16.3252 16.9355 14.7798 16.9355 12.8736C16.9355 10.9673 15.3901 9.42194 13.4838 9.42194C11.5776 9.42194 10.0322 10.9673 10.0322 12.8736C10.0322 14.7798 11.5776 16.3252 13.4838 16.3252Z"
        fill="white"
      />
      <path
        d="M22.9991 18.0977V36.5685V18.0977ZM13.4838 18.0977V36.5685V18.0977Z"
        fill="white"
      />
      <path
        d="M22.9991 18.0977V36.5685M13.4838 18.0977V36.5685"
        stroke="white"
        strokeWidth="6.12914"
      />
      <path
        d="M25.9843 26.3069C25.9843 24.4411 27.197 22.5754 29.3426 22.5754C31.5815 22.5754 32.4211 24.2546 32.4211 26.7733V36.5684H38.578V26.027C38.578 20.3365 35.5928 17.7245 31.4882 17.7245C28.3165 17.7245 26.7306 19.4969 25.9843 20.7097"
        fill="white"
      />
    </svg>
  )
}
